import React, { useState } from "react";
import styled from "styled-components";

import TitleImage from "../../../assets/intro/title.png";
import LogoImage from "../../../assets/logo/logo_youth.png";

import LongButton from "../../shared/LongButton";

const Page = styled.div`
  position: relative;
  background-color: #1e1e1e;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
  position: relative;
  color: ${(props) => props.theme.color.white};
  font-size: 13px;
  font-weight: 500;
  margin-top: 140px;
  margin-bottom: 125px;
  p {
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
  }
`;

const PlaceHolder = styled.div`
  width: 360px;
  height: 270px;
`;

const Logo = styled.img`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
`;

const IntroPage1 = ({ setCurrentPage }) => {
  const [loading, setLoading] = useState(true);

  return (
    <Page>
      <Title>
        <p>feat. 우리 집은 며칠 만에 쓰레기장이 될까?</p>
        {loading && <PlaceHolder />}
        <img
          src={TitleImage}
          alt="쓰레기통이 사라졌다!"
          onLoad={() => setLoading(false)}
        />
      </Title>
      <LongButton text="테스트 하러 가기" onClick={() => setCurrentPage(2)} />
      <a
        href="https://www.peoplepower21.org/Youth"
        target="_blank"
        rel="noreferrer"
      >
        <Logo src={LogoImage} alt="세상을 바꾸는 청년 참여연대" />
      </a>
    </Page>
  );
};

export default IntroPage1;
